import request, { post } from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login/index',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/index/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/user/login/logout',
    method: 'post'
  })
}

export function repass(data) {
  return request({
    url: '/user/set/repass',
    method: 'post',
    data
  })
  // return post('/admin/users/changePwd', data)
}

export function register(data) {
  return request({
    url: '/user/login/reg',
    method: 'post',
    data
  })
}

export function sendMobileCode(phone) {
  return request({
    url: '/user/login/sendMobileCode',
    method: 'post',
    data: {
      phone
    }
  })
}

export function forgetByUserMobile(data){
  return request({
    url: '/user/login/forgetByUserMobile',
    method: 'post',
    data
  })
}
